var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpreadsheetsAmico(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-2",
    cx: 249.05,
    cy: 341.22,
    rx: 240.64,
    ry: 138.94,
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-2",
    cx: 380.87,
    cy: 402.79,
    rx: 48.21,
    ry: 27.83,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M67.46,390.32,27.93,367.5c-2.23-1.29-2.23-3.37,0-4.66L257.87,230.08a9,9,0,0,1,8.07,0l39.54,22.83c2.23,1.28,2.23,3.37,0,4.66L75.54,390.32A8.92,8.92,0,0,1,67.46,390.32Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Cloud--inject-2",
    d: "M94,52.74,85.09,57.9c0-.4.07-.79.07-1.18V54.13c0-4.61-3.23-6.48-7.23-4.17a14,14,0,0,0-4.3,4.14c-.66-5.8-5.2-8-10.73-4.77-6,3.45-10.81,11.83-10.81,18.73v3.87A10.13,10.13,0,0,0,53,76.42l-7.43,4.29a8.88,8.88,0,0,0-4,6.94c0,2.56,1.8,3.6,4,2.32L94,62a8.87,8.87,0,0,0,4-6.94C98,52.5,96.24,51.46,94,52.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--cloud--inject-2",
    d: "M140.32,74.16l-6.75,3.9a6.92,6.92,0,0,0,.06-.9v-2c0-3.48-2.44-4.89-5.45-3.15a10.45,10.45,0,0,0-3.25,3.12c-.5-4.37-3.93-6-8.1-3.59-4.5,2.6-8.16,8.93-8.16,14.13v2.93a7.7,7.7,0,0,0,.69,3.38l-5.6,3.24a6.69,6.69,0,0,0-3,5.24c0,1.93,1.36,2.71,3,1.75l36.56-21.11a6.7,6.7,0,0,0,3-5.24C143.35,74,142,73.2,140.32,74.16Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Monitor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.56,349.65l34-19.65c3.51-2,5.26-4.68,5.26-7.33s0-4.72,0-4.72l-35.26-19.89a7.48,7.48,0,0,1-3.38-5.86V250.3l-59.36,34.3v41.9a7.5,7.5,0,0,0,3.38,5.86l30,17.29C191.19,353.69,202.55,353.69,209.56,349.65Z",
    style: {
      fill: "#263238"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.06,333.92v4.71l-10.88-6.27a7.48,7.48,0,0,1-3.37-5.86V284.61l11.3-6.53c.24,2.87.49,5.84.73,8.73l-7.93,4.59v32.74a7.43,7.43,0,0,0,3.38,5.86Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M154.91,324.15a7.48,7.48,0,0,0,3.38,5.86l25.89,14.91c7,4.05,18.37,4.05,25.38,0l34-19.64c7-4,7-10.6,0-14.65L217.65,295.7a7.45,7.45,0,0,1-3.38-5.86V257.11l-59.35,34.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.54,299.69h0l-6.89-4a7.45,7.45,0,0,1-3.38-5.86V257.11l-59.36,34.3v32.74a7.48,7.48,0,0,0,3.38,5.86l6.77,3.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.81,318v4.73c0,2.65-1.76,5.29-5.26,7.32l-34,19.64a25.49,25.49,0,0,1-12.11,3v-4.71a25.37,25.37,0,0,0,12.11-3l34-19.66C247.05,323.26,248.81,320.61,248.81,318Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6,364.84a9.07,9.07,0,0,0,8.19-.15L297.35,232.15a9.31,9.31,0,0,0,4.23-7.32V38.52a9.09,9.09,0,0,0-4-7.17,9.07,9.07,0,0,0-8.19.15L59.86,164a9.34,9.34,0,0,0-4.23,7.32V357.67A9.09,9.09,0,0,0,59.6,364.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.79,364.68,297.35,232.15a9.34,9.34,0,0,0,4.23-7.32V38.52c0-2.7-1.89-3.79-4.23-2.44L67.8,168.61a9.34,9.34,0,0,0-4.23,7.32V362.24C63.57,364.94,65.46,366,67.79,364.68Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.79,364.68,297.35,232.15a9.34,9.34,0,0,0,4.23-7.32V38.52c0-2.7-1.89-3.79-4.23-2.44L67.8,168.61a9.34,9.34,0,0,0-4.23,7.32V362.24C63.57,364.94,65.46,366,67.79,364.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.17,369.51a9.13,9.13,0,0,1-7.58-.16,9.09,9.09,0,0,1-4-7.18V345.26l7.93,4.59v16.91C63.56,369.22,65.12,370.33,67.17,369.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.56,349.85v16.9c0,2.7,1.89,3.79,4.22,2.44L297.35,236.66a9.34,9.34,0,0,0,4.23-7.33V212.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.57,349.81v16.94c0,2.7,1.89,3.79,4.22,2.44L297.35,236.66a9.34,9.34,0,0,0,4.23-7.33V212.4Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5,328.63V178.57a5.62,5.62,0,0,1,2.54-4.4L291.1,48.85c1.41-.81,2.54-.15,2.54,1.46V200.38a5.62,5.62,0,0,1-2.54,4.4L74,330.1C72.63,330.91,71.5,330.25,71.5,328.63Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5,328.63V178.57a5.62,5.62,0,0,1,2.54-4.4L291.1,48.85c1.41-.81,2.54-.15,2.54,1.46V200.38a5.62,5.62,0,0,1-2.54,4.4L74,330.1C72.63,330.91,71.5,330.25,71.5,328.63Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.57,286.5a8.78,8.78,0,0,0-4,6.87c0,2.53,1.78,3.56,4,2.29a8.76,8.76,0,0,0,4-6.87C186.54,286.26,184.76,285.23,182.57,286.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.81,171.75a9,9,0,0,0-1.25,4.18V349.85l-7.93-4.59V171.36a8.77,8.77,0,0,1,1.25-4.18Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Spreadsheets--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.55,37.64a2.09,2.09,0,0,0-2.16.17L102.6,169.94a6.55,6.55,0,0,0-3,5.13V329.32a2.86,2.86,0,0,0,1.25,2.57c.48.26,3,1.74,3.78,2.15a1.7,1.7,0,0,0,1.72-.1L335.17,201.76a6.54,6.54,0,0,0,3-5.13v-155a2.07,2.07,0,0,0-.92-2C336.69,39.44,334.09,38,333.55,37.64Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.39,172.09,335.17,40c1.64-.94,3-.17,3,1.72v155a6.54,6.54,0,0,1-3,5.13L106.39,333.94c-1.64.94-3-.59-3-2.48V177.22A6.54,6.54,0,0,1,106.39,172.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.5,40.55h0c.55,0,.64.7.64,1.12v155a5.52,5.52,0,0,1-2.47,4.26L105.89,333.07a.91.91,0,0,1-.48.16c-.52,0-1-.83-1-1.77V177.22a5.54,5.54,0,0,1,2.47-4.27L335.67,40.82a1.76,1.76,0,0,1,.83-.27m0-1a2.76,2.76,0,0,0-1.33.4L106.39,172.09a6.54,6.54,0,0,0-3,5.13V331.46c0,1.5.83,2.77,2,2.77a1.93,1.93,0,0,0,1-.29L335.17,201.76a6.54,6.54,0,0,0,3-5.13v-155c0-1.35-.67-2.12-1.64-2.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.88,331.89c.32.17,2.63,1.49,3.64,2.06a3,3,0,0,1-1.09-2.49V186.91l-3.8-2.22V329.32A2.9,2.9,0,0,0,100.88,331.89Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.14,41.64c0-1.87-1.34-2.63-3-1.69L106.39,172.09a6.54,6.54,0,0,0-3,5.13v9.69L338.14,51.37Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.17,40,106.39,172.09a6,6,0,0,0-2.09,2.2l-3.76-2.18a5.91,5.91,0,0,1,2.06-2.17L331.39,37.81a2.1,2.1,0,0,1,2.15-.18c.53.33,3,1.73,3.62,2.06A2.18,2.18,0,0,0,335.17,40Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.63,184.7v-9.63a6.11,6.11,0,0,1,.91-3l3.77,2.17a6,6,0,0,0-.88,2.94v9.69Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.43 186.91 103.42 204.37 338.13 68.85 338.13 51.37 103.43 186.91",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.2 185.62 128.38 176.9 128.38 185.59 113.19 194.36 113.2 185.62",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.13 174.69 132.13 178.13 139.7 173.75 139.7 170.32 132.13 174.69",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.13 180 132.13 183.44 139.7 179.06 139.7 175.63 132.13 180",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.49 168.13 143.49 171.57 151.06 167.2 151.06 163.76 143.49 168.13",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.49 173.44 143.49 176.88 151.06 172.51 151.06 169.07 143.49 173.44",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.84 161.57 154.84 165.01 162.41 160.64 162.41 157.2 154.84 161.57",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.84 166.88 154.84 170.32 162.41 165.95 162.41 162.51 154.84 166.88",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.91 141.9 188.91 145.34 196.48 140.97 196.48 137.53 188.91 141.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.91 147.22 188.91 150.65 196.48 146.28 196.48 142.84 188.91 147.22",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.27 135.35 200.27 138.78 207.84 134.41 207.84 130.97 200.27 135.35",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.27 140.66 200.27 144.09 207.84 139.72 207.84 136.28 200.27 140.66",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.62 128.79 211.63 132.23 219.2 127.86 219.2 124.42 211.62 128.79",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.62 134.1 211.63 137.54 219.2 133.16 219.2 129.73 211.62 134.1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.2 155.02 185.13 144.09 185.13 152.83 166.2 163.76 166.2 155.02",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.99 122.23 238.17 113.51 238.17 122.21 222.98 130.98 222.99 122.23",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.91 111.3 241.92 114.74 249.49 110.37 249.49 106.93 241.91 111.3",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.91 116.61 241.92 120.05 249.49 115.68 249.49 112.24 241.91 116.61",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.27 104.75 253.27 108.19 260.84 103.81 260.84 100.37 253.27 104.75",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.27 110.06 253.27 113.5 260.84 109.12 260.84 105.68 253.27 110.06",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.63 98.19 264.63 101.63 272.2 97.25 272.2 93.81 264.63 98.19",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.63 103.5 264.63 106.94 272.2 102.56 272.2 99.13 264.63 103.5",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.7 78.52 298.7 81.96 306.27 77.58 306.27 74.14 298.7 78.52",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.7 83.83 298.7 87.27 306.27 82.89 306.27 79.46 298.7 83.83",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.06 71.96 310.06 75.4 317.63 71.03 317.63 67.59 310.06 71.96",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.06 77.27 310.06 80.71 317.63 76.34 317.63 72.9 310.06 77.27",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.41 65.4 321.41 68.84 328.99 64.47 328.99 61.03 321.41 65.4",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.41 70.71 321.41 74.15 328.99 69.78 328.99 66.34 321.41 70.71",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.99 91.63 294.92 80.7 294.92 89.45 275.99 100.37 275.99 91.63",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.43 186.91 99.63 184.69 99.63 202.18 103.42 204.37 103.43 186.91",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.57,79.46v.65c0,1,.72,1.44,1.61.93l46-26.55a3.58,3.58,0,0,0,1.61-2.8v-.64c0-1-.72-1.45-1.61-.93l-46,26.55A3.55,3.55,0,0,0,277.57,79.46Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.78,51.69v-.64c0-1-.72-1.45-1.61-.93l-6,3.44h0v4.37h0l6-3.44A3.58,3.58,0,0,0,326.78,51.69Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--spreadsheets--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "107.21 206.54 334.36 75.42 334.36 84.14 126.13 204.37 126.13 318.02 107.21 328.94 107.21 206.54",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.13 204.37 145.05 193.45 145.05 202.17 126.13 213.11 126.13 204.37",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.13 274.3 145.05 263.38 145.05 272.1 126.13 283.04 126.13 274.3",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.13 283.04 145.05 272.12 145.05 280.84 126.13 291.78 126.13 283.04",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.13 283.04 145.05 272.12 145.05 280.84 126.13 291.78 126.13 283.04",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.69 208.73 258.61 197.81 258.61 206.53 239.69 217.47 239.69 208.73",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.69 208.73 258.61 197.81 258.61 206.53 239.69 217.47 239.69 208.73",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.69 217.47 258.61 206.55 258.61 215.27 239.69 226.21 239.69 217.47",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.69 217.47 258.61 206.55 258.61 215.27 239.69 226.21 239.69 217.47",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.69 226.22 258.61 215.3 258.61 224.02 239.69 234.96 239.69 226.22",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.69 226.22 258.61 215.3 258.61 224.02 239.69 234.96 239.69 226.22",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.69 234.96 258.61 224.04 258.61 232.76 239.69 243.7 239.69 234.96",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.69 234.96 258.61 224.04 258.61 232.76 239.69 243.7 239.69 234.96",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.78 149.72 239.69 138.8 239.69 182.51 220.78 193.45 220.78 149.72",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.78 202.18 239.69 191.26 239.69 252.45 220.78 263.39 220.78 202.18",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.05 245.89 163.96 234.97 163.96 243.69 145.05 254.63 145.05 245.89",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.05 245.89 163.96 234.97 163.96 243.69 145.05 254.63 145.05 245.89",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.92 180.32 201.84 169.4 201.84 178.12 182.92 189.06 182.92 180.32",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.92 180.32 201.84 169.4 201.84 178.12 182.92 189.06 182.92 180.32",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.57 178.13 296.48 167.21 296.48 175.93 277.57 186.87 277.57 178.13",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.57 178.13 296.48 167.21 296.48 175.93 277.57 186.87 277.57 178.13",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.57 195.62 296.48 184.7 296.48 193.42 277.57 204.36 277.57 195.62",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,206.15l-.23.13V329.76L334.58,198.21l.24-.13V74.6Zm226.91-17.33-18,10.39v-7.67l18-10.38ZM107.68,215.56l18-10.39v7.67l-18,10.39ZM220.32,203v7.67l-18,10.39v-7.67Zm-18,9.31v-7.67l18-10.39v7.67Zm18.93-9.85,18-10.39v7.67l-18,10.39Zm0-1.08v-7.66l18-10.4V191Zm0-8.74V185l18-10.39v7.67Zm0-8.75v-7.66l18-10.4v7.67Zm-.93.54-18,10.39v-7.67l18-10.39Zm0,1.08v7.67l-18,10.39V195.9Zm-18.93,18.6-18,10.39v-7.67l18-10.39Zm0,1.07v7.67l-18,10.39v-7.67Zm0,8.75v7.67l-18,10.39v-7.67Zm0,8.74v7.67l-18,10.39v-7.67Zm.93-.54,18-10.39v7.67l-18,10.39Zm18-1.64v7.67l-18,10.39v-7.67Zm.93-.54,18-10.39v7.67l-18,10.39Zm0-1.08V211.2l18-10.39v7.67Zm18.93-18.59,18-10.39v7.67l-18,10.39Zm0-1.08v-7.67l18-10.39v7.67Zm0-8.74v-7.67l18-10.39v7.67Zm0-8.75V174l18-10.39v7.67Zm0-8.74V165.3l18-10.39v7.66Zm0-8.75v-7.67l18-10.39v7.67Zm-.93.54-18,10.39v-7.67l18-10.39Zm-18.93,10.93-18,10.39v-7.67l18-10.39Zm-18.93,10.93-18,10.39v-7.67l18-10.39Zm0,1.07v7.67l-18,10.39v-7.67Zm-18.93,18.6-18,10.39V209l18-10.39Zm0,1.08V215l-18,10.4v-7.67Zm0,8.74v7.67l-18,10.39V226.5Zm0,8.75v7.66l-18,10.4v-7.67Zm0,8.74v7.67l-18,10.39V244Zm0,8.75V250l-18,10.4v-7.67Zm.93-.54,18-10.39v7.67l-18,10.39Zm18-1.65v7.67l-18,10.39v-7.67Zm.93-.54,18-10.39v7.67l-18,10.39Zm18.93-10.93,18-10.39V226l-18,10.39Zm18.93-10.92,18-10.39v7.67l-18,10.39Zm0-1.08V209l18-10.39v7.67Zm18.93-18.6,18-10.39v7.67l-18,10.39Zm0-1.07v-7.67l18-10.39v7.67Zm0-8.75V180.6l18-10.39v7.67Zm0-8.74v-7.67l18-10.39v7.67Zm0-8.75v-7.67l18-10.39v7.67Zm0-8.74v-7.67l18-10.39v7.67Zm0-8.75v-7.67l18-10.39v7.67Zm0-8.74v-7.67l18-10.39v7.67Zm-.93.53-18,10.4v-7.67l18-10.39ZM239.25,156l-18,10.39v-7.66l18-10.4Zm-18.93,10.93-18,10.39v-7.67l18-10.39Zm-18.93,10.93-18,10.39v-7.67l18-10.39ZM182.46,188.8l-18,10.39v-7.67l18-10.39Zm0,1.08v7.66l-18,10.4v-7.67Zm-18.93,18.59-18,10.39V211.2l18-10.4Zm0,1.08v7.67l-18,10.39v-7.67Zm0,8.74V226l-18,10.39v-7.67Zm0,8.75v7.67l-18,10.39v-7.67Zm0,8.74v7.67l-18,10.39v-7.66Zm0,8.75v7.67l-18,10.39v-7.67Zm0,8.74v7.67l-18,10.39v-7.66Zm0,8.75v7.67l-18,10.39v-7.67Zm.93-.54,18-10.39v7.67l-18,10.39Zm18-1.64v7.67l-18,10.39v-7.67Zm.93-.54,18-10.39v7.67l-18,10.39Zm18.93-10.93,18-10.39v7.67l-18,10.39Zm18.93-10.93,18-10.39v7.67l-18,10.39Zm18.93-10.93,18-10.39v7.67l-18,10.39Zm18.93-10.93,18-10.39v7.67l-18,10.39Zm0-1.07v-7.67l18-10.39v7.67ZM278,195.91l18-10.39v7.67l-18,10.39Zm0-1.08v-7.67l18-10.39v7.67Zm0-8.74v-7.67L296,168v7.67Zm0-8.75v-7.67l18-10.39V167Zm0-8.74v-7.67l18-10.39v7.67Zm0-8.75v-7.67l18-10.39v7.67Zm0-8.74v-7.67l18-10.39v7.67Zm0-8.75v-7.67l18-10.39V132Zm0-8.74V126l18-10.39v7.67Zm0-8.75V117.2l18-10.39v7.67Zm-.93.54-18,10.39v-7.67l18-10.39Zm-18.93,10.93-18,10.39v-7.67l18-10.39Zm-18.93,10.93-18,10.39V150l18-10.39ZM220.32,158.2l-18,10.39v-7.67l18-10.39Zm-18.93,10.93-18,10.39v-7.67l18-10.39Zm-18.93,10.92-18,10.4v-7.67l18-10.39ZM163.53,191l-18,10.39v-7.66l18-10.4Zm0,1.08v7.67l-18,10.39v-7.67Zm-18.93,18.6-18,10.39v-7.67l18-10.39Zm0,1.07v7.67l-18,10.39v-7.67Zm0,8.75v7.67l-18,10.39v-7.67Zm0,8.74v7.67l-18,10.39v-7.67Zm0,8.75v7.67L126.6,256v-7.67Zm0,8.74v7.67l-18,10.39V257.1Zm0,8.75v7.67l-18,10.39v-7.67Zm0,8.74v7.67l-18,10.39v-7.67Zm0,8.75v7.67L126.6,291v-7.67Zm0,8.74v7.67l-18,10.39v-7.67Zm.93-.53,18-10.4v7.67l-18,10.39Zm18-1.65v7.67l-18,10.39V289.9Zm.93-.54,18-10.39v7.67l-18,10.39ZM183.39,268l18-10.39v7.67l-18,10.39Zm18.93-10.93,18-10.39v7.67l-18,10.39Zm18.93-10.92,18-10.4v7.67l-18,10.39Zm18.93-10.93,18-10.39v7.67l-18,10.39Zm18.93-10.93,18-10.39v7.67l-18,10.39ZM278,213.4,296,203v7.67l-18,10.39Zm0-1.08v-7.67l18-10.39v7.67ZM297,193.73l18-10.4V191l-18,10.39Zm0-1.08V185l18-10.39v7.67Zm0-8.75v-7.66l18-10.4v7.67Zm0-8.74v-7.67l18-10.39v7.67Zm0-8.75v-7.66l18-10.4V156Zm0-8.74V150l18-10.39v7.67Zm0-8.75v-7.66l18-10.4v7.67Zm0-8.74v-7.67l18-10.39v7.67Zm0-8.75v-7.66l18-10.4V121Zm0-8.74V115l18-10.39v7.67Zm0-8.75v-7.66l18-10.4v7.67Zm0-8.74V97.53l18-10.39v7.67Zm-.94.54-18,10.39v-7.67l18-10.39Zm-18.92,10.93-18,10.39v-7.67l18-10.39Zm-18.93,10.92-18,10.4v-7.67l18-10.39Zm-18.93,10.93-18,10.39v-7.66l18-10.39Zm-18.93,10.93-18,10.39v-7.66l18-10.39Zm-18.93,10.93-18,10.39v-7.66l18-10.39Zm-18.93,10.93-18,10.39V174l18-10.39Zm-18.93,10.93-18,10.39V185l18-10.4ZM144.6,193.17l-18,10.39v-7.67l18-10.39Zm0,1.07v7.67l-18,10.39v-7.67Zm-36.92,30.07,18-10.39v7.67l-18,10.39Zm0,8.74,18-10.39v7.67l-18,10.39Zm0,8.75,18-10.39v7.67l-18,10.39Zm0,8.74,18-10.39v7.67l-18,10.39Zm0,8.75,18-10.39v7.67l-18,10.39Zm0,8.74,18-10.39v7.67l-18,10.39Zm0,8.75,18-10.39v7.67l-18,10.39Zm0,8.74,18-10.39v7.67l-18,10.39Zm0,8.75,18-10.39v7.67l-18,10.39Zm0,8.74,18-10.39v7.67l-18,10.39Zm0,8.75,18-10.39V309l-18,10.39Zm18.92-10.93,18-10.39v7.67l-18,10.39Zm18-1.65v7.64l-18,10.4v-7.65Zm.93-.54,18-10.39v7.65l-18,10.39Zm18.93-10.92,18-10.39V285l-18,10.39Zm18.93-10.93,18-10.39V274l-18,10.39Zm18.93-10.93,18-10.39v7.64l-18,10.39Zm18.93-10.93,18-10.39v7.64l-18,10.39ZM240.18,244l18-10.39v7.64l-18,10.39Zm18.93-10.93,18-10.39v7.64l-18,10.39ZM278,222.14l18-10.39v7.64l-18,10.39ZM297,211.22l18-10.4v7.64l-18,10.39Zm0-1.08v-7.67l18-10.39v7.67Zm36.92-30.06-18,10.39V182.8l18-10.39Zm0-8.75-18,10.39v-7.67l18-10.38Zm0-8.74L315.9,173v-7.67l18-10.39Zm0-8.75-18,10.39v-7.67l18-10.39Zm0-8.74-18,10.39v-7.67l18-10.39Zm0-8.75-18,10.39v-7.67l18-10.39Zm0-8.74L315.9,138v-7.67l18-10.39Zm0-8.75-18,10.39v-7.67l18-10.39Zm0-8.74-18,10.39v-7.67l18-10.39Zm0-8.75-18,10.39v-7.67l18-10.39Zm0-8.74L315.9,103V95.35l18-10.39Zm0-8.75-18,10.39V86.61l18-10.39ZM125.67,196.43v7.67l-18,10.38v-7.66Zm-18,124.07,18-10.39v7.64l-18,10.39ZM315.9,207.93v-7.64l18-10.39v7.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.61 127.85 334.36 84.15 334.36 127.88 258.61 171.56 258.61 127.85",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.1,172.43V127.56l.25-.14,76.5-44.13v44.88Zm1-44.29V170.7l74.75-43.11V85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.43,161l-.12,0a.39.39,0,0,1-.23-.49l10.24-28a.38.38,0,0,1,.54-.19L283.93,139l11.17-11.38a.38.38,0,0,1,.48,0l11,7.23,11.17-27.52a.38.38,0,0,1,.52-.19l11.35,5.82a.37.37,0,1,1-.34.66l-11-5.63-11.2,27.57a.36.36,0,0,1-.24.21.34.34,0,0,1-.31,0l-11.1-7.31-11.16,11.37a.38.38,0,0,1-.46.06l-10.93-6.54-10.08,27.53A.39.39,0,0,1,262.43,161Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.67,131.38a2.52,2.52,0,0,0-1.14,2c0,.73.51,1,1.14.66a2.53,2.53,0,0,0,1.14-2C273.81,131.31,273.3,131,272.67,131.38Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,138.14a2.55,2.55,0,0,0-1.14,2c0,.73.51,1,1.14.66a2.55,2.55,0,0,0,1.14-2C285.16,138.08,284.65,137.78,284,138.14Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.37,126.55a2.55,2.55,0,0,0-1.14,2c0,.73.51,1,1.14.66a2.53,2.53,0,0,0,1.14-2C296.51,126.49,296,126.19,295.37,126.55Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.72,134a2.52,2.52,0,0,0-1.14,2c0,.73.51,1,1.14.66a2.52,2.52,0,0,0,1.14-2C307.86,134,307.35,133.67,306.72,134Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.07,106.09a2.52,2.52,0,0,0-1.14,2c0,.73.51,1,1.14.66a2.53,2.53,0,0,0,1.14-2C319.21,106,318.7,105.72,318.07,106.09Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.42,111.91a2.52,2.52,0,0,0-1.14,2c0,.73.51,1,1.14.66a2.52,2.52,0,0,0,1.14-2C330.56,111.84,330.05,111.54,329.42,111.91Z",
    style: {
      fill: "#1976D2"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Charts--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--charts--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "365.87 245.19 345.73 256.82 365.87 268.45 386.01 256.82 365.87 245.19",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.01 256.8 386.01 303.05 365.87 314.68 365.87 268.46 386.01 256.8",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.87 268.46 365.87 314.68 345.73 303.05 345.73 256.8 365.87 268.46",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.37 280.55 319.23 292.18 339.37 303.81 359.51 292.18 339.37 280.55",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.37 280.55 319.23 292.18 339.37 303.81 359.51 292.18 339.37 280.55",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.51 292.15 359.51 318.35 339.37 329.98 339.37 303.81 359.51 292.15",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.37 303.81 339.37 329.98 319.23 318.35 319.23 292.16 339.37 303.81",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.37 303.81 339.37 329.98 319.23 318.35 319.23 292.16 339.37 303.81",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.87 284.97 292.73 296.6 312.87 308.23 333.01 296.6 312.87 284.97",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.87 284.97 292.73 296.6 312.87 308.23 333.01 296.6 312.87 284.97",
    style: {
      fill: "#fff",
      opacity: 0.88
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.01 296.58 333.01 333.65 312.87 345.28 312.87 308.23 333.01 296.58",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.01 296.58 333.01 333.65 312.87 345.28 312.87 308.23 333.01 296.58",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.87 308.23 312.87 345.28 292.73 333.65 292.73 296.58 312.87 308.23",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.87 308.23 312.87 345.28 292.73 333.65 292.73 296.58 312.87 308.23",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.37 324.25 266.23 335.88 286.37 347.51 306.51 335.88 286.37 324.25",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.37 324.25 266.23 335.88 286.37 347.51 306.51 335.88 286.37 324.25",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.51 335.85 306.51 348.95 286.37 360.58 286.37 347.51 306.51 335.85",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.51 335.85 306.51 348.95 286.37 360.58 286.37 347.51 306.51 335.85",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.37 347.51 286.37 360.58 266.23 348.95 266.23 335.85 286.37 347.51",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.37 347.51 286.37 360.58 266.23 348.95 266.23 335.85 286.37 347.51",
    style: {
      opacity: 0.55
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--charts--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.65,405.6v7.63l-7.53-20.47v-7.61h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.66 405.61 176.66 413.23 207.72 402.45 207.72 394.83 176.66 405.61",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.12,385.14l7.54,20.47,31.06-10.78C199.19,387.39,184.36,383.67,169.12,385.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.67,407a1.77,1.77,0,0,0,0,.23V407Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.56,415.22,169,436.92c-18.83-1.84-32.44-11.36-32.28-22.25v-7.42c0,10.8,13.57,20.23,32.29,22.05l3.16-14.91Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.56,415.22,169,436.92c-18.83-1.84-32.44-11.36-32.28-22.25v-7.42c0,10.8,13.57,20.23,32.29,22.05l3.16-14.91Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.48,429.55v7.62A60.11,60.11,0,0,0,195.4,434c8.88-3.08,15.15-8,17.66-13.77a13.8,13.8,0,0,0,1.16-5.32c0-.73,0-7.88,0-7.88s-2.15-.17-4.67-2.85l-5.82,2-26.63,9.24Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.48,429.55v7.62A60.11,60.11,0,0,0,195.4,434c8.88-3.08,15.15-8,17.66-13.77a13.8,13.8,0,0,0,1.16-5.32c0-.73,0-7.88,0-7.88s-2.15-.17-4.67-2.85l-5.82,2-26.63,9.24Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.3 398.31 172.44 411.67 172.44 404.05 149.3 390.69 149.3 398.31",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.3 398.31 172.44 411.67 172.44 404.05 149.3 390.69 149.3 398.31",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,404.5c-2.53,11.91,11.71,22.82,32,24.8l4.61-21.7-26.78-15.46C141.19,395.65,138,399.7,137,404.5Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,404.5c-2.53,11.91,11.71,22.82,32,24.8l4.61-21.7-26.78-15.46C141.19,395.65,138,399.7,137,404.5Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.61,428.92l-.13.63a60.11,60.11,0,0,0,22.92-3.13c8.88-3.08,15.15-8,17.66-13.77,2.36-5.47,1.11-11.13-3.51-16l-5.82,2-26.63,9.24Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.61,428.92l-.13.63a60.11,60.11,0,0,0,22.92-3.13c8.88-3.08,15.15-8,17.66-13.77,2.36-5.47,1.11-11.13-3.51-16l-5.82,2-26.63,9.24Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.3,390.69l23.14,13.36-6.8-18.48A47.39,47.39,0,0,0,149.3,390.69Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.56 415.22 173.56 407.6 168.94 429.3 168.94 436.92 173.56 415.22",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.56 415.22 173.56 407.6 168.94 429.3 168.94 436.92 173.56 415.22",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.08 373.71 198.04 376.62 203.08 379.53 208.12 376.62 203.08 373.71",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.08 373.71 198.04 376.62 203.08 379.53 208.12 376.62 203.08 373.71",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.12 376.62 208.12 379.54 203.08 382.45 203.08 379.53 208.12 376.62",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.12 376.62 208.12 379.54 203.08 382.45 203.08 379.53 208.12 376.62",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.08 379.53 203.08 382.45 198.04 379.54 198.04 376.62 203.08 379.53",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.08 379.53 203.08 382.45 198.04 379.54 198.04 376.62 203.08 379.53",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.78,371.45l18.68-10.78a4.32,4.32,0,0,1,3.91-.07c1,.6,1,1.61-.13,2.26l-18.68,10.78a4.35,4.35,0,0,1-3.91.07C209.61,373.11,209.66,372.1,210.78,371.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.44 380.27 209.4 383.18 214.44 386.09 219.48 383.18 214.44 380.27",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.44 380.27 209.4 383.18 214.44 386.09 219.48 383.18 214.44 380.27",
    style: {
      fill: "#fff",
      opacity: 0.88
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.48 383.17 219.48 386.09 214.44 389 214.44 386.09 219.48 383.17",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.48 383.17 219.48 386.09 214.44 389 214.44 386.09 219.48 383.17",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.44 386.09 214.44 389 209.4 386.09 209.4 383.17 214.44 386.09",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.44 386.09 214.44 389 209.4 386.09 209.4 383.17 214.44 386.09",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.14,378l18.67-10.78a4.32,4.32,0,0,1,3.91-.08c1.05.61,1,1.62-.12,2.26L225.92,380.2a4.35,4.35,0,0,1-3.91.07C221,379.66,221,378.65,222.14,378Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.79 386.83 220.75 389.74 225.8 392.65 230.84 389.74 225.79 386.83",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.79 386.83 220.75 389.74 225.8 392.65 230.84 389.74 225.79 386.83",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.84 389.73 230.84 392.65 225.8 395.56 225.8 392.65 230.84 389.73",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.8 392.65 225.8 395.56 220.75 392.65 220.75 389.73 225.8 392.65",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.8 392.65 225.8 395.56 220.75 392.65 220.75 389.73 225.8 392.65",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.49,384.57l18.68-10.79a4.35,4.35,0,0,1,3.91-.07c1.05.61,1,1.62-.12,2.26l-18.68,10.78a4.32,4.32,0,0,1-3.91.08C232.32,386.22,232.38,385.21,233.49,384.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.15 393.38 232.11 396.29 237.15 399.2 242.19 396.29 237.15 393.38",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.19 396.29 242.19 399.21 237.15 402.12 237.15 399.2 242.19 396.29",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.15 399.2 237.15 402.12 232.11 399.21 232.11 396.29 237.15 399.2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.85,391.13l18.68-10.79a4.35,4.35,0,0,1,3.91-.07c1.05.6,1,1.61-.13,2.26l-18.67,10.78a4.32,4.32,0,0,1-3.91.07C243.68,392.78,243.74,391.77,244.85,391.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.23,235.48c6.93,0,10.22,2,12.72,8.58s9.11,21.85,9.24,26.37c.14,4.69-15,18.91-14.42,18.67.16-.08-4.61-8.62-4.61-8.62l8.5-10.41-4.87-14.13Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.81,390.85c.43.41.51.8.49,2.28s.61,3.13-.15,4.51c-.56,1-3.46,1.74-4.93,1a15.13,15.13,0,0,1-3.4-3.05,23.68,23.68,0,0,0-3-2.87c-1.25-.93-2.7-1.55-4-2.4a8,8,0,0,1-3.62-6,3.87,3.87,0,0,1,.46-2.28,2.6,2.6,0,0,1,2.61-.86c1.41.23,6.19,2.9,7.29,3.66C397,385.78,403.37,390.43,403.81,390.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.79,384.73c-.05,1.06-4.52-1.42-6.35-1.18l-.05,0c-1.71.82-.29,3.21,1.29,4.43s6.76,5,6.76,5l1.06-6.13Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.39,402c.83,0,1.2,2.72,1.36,4.81.11,1.62.73,4.27.15,5.46s-2.75,1.93-6.12,1.86c-2.19,0-5.61,1.39-7.95,2.66a12,12,0,0,1-7.58.95c-3-.39-6.08-2.17-6.55-3.41s.17-1.84,7.27-4.76c.07,0,7.5-3.27,11-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,409.57c-1,.4-1.83.76-2.58,1.08-.19.67.07,1.74,3.21,2.26,4.78.8,18.84-9.79,18.84-9.79s-2,.56-2.39-.59l-6.11,0C365.47,406.3,358,409.54,358,409.57Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.66,356.07a60.71,60.71,0,0,0-1.38-13.87s.84-17.86.93-29.08c.19-22.2-.23-25.46-5.14-35,0,0-28.67-3.35-29.88,10.62-1.5,17.4-3.25,46.51-3.21,54.8,0,6.17.74,12.86,1.08,26.85.22,9,1.16,21.62-.12,32.22,1.62,2.72,6,2.67,8.5.55.72-10.38,5.88-30.26,6.68-37.19a58.93,58.93,0,0,0-.62-15s3.8-29.64,4.47-34.15a83.84,83.84,0,0,1,1.66,14.48c0,2,.68,8.57,1.81,19.67.69,6.76,5.47,33.18,6.51,41.67,2.4,2.32,5.5.72,5.64-.28C404.39,382,406.66,362.54,406.66,356.07Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,316.79l2.53-14.39a19.69,19.69,0,0,0,11.29-5.92s-1.52,5.75-9,7.71l-3,13-.5,11.87Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.78 230.65 381.97 243.69 393.43 243 392.55 228.53 380.78 230.65",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.78,281.59a52.78,52.78,0,0,0-5-9.91c4.9-15.78,6.47-21.09,5.52-27.84-.61-4.29-4-8.58-8.16-8.35H393c-.18,3-8.49,3.13-11.64,1.07l-2.91.08c-2.05.73-9,11-9.8,17.75-.63,5.51,3.7,10.29,3.7,10.29a53.79,53.79,0,0,1-.41,7s0,13.35,0,20c0,0,1.61,5.12,18.43,3.52,15-1.42,15.32-6.53,15.32-6.53A31.46,31.46,0,0,0,403.78,281.59Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M403.78,281.59a52.78,52.78,0,0,0-5-9.91c4.9-15.78,6.47-21.09,5.52-27.84-.61-4.29-4-8.58-8.16-8.35H393c-.18,3-8.49,3.13-11.64,1.07l-2.91.08c-2.05.73-9,11-9.8,17.75-.63,5.51,3.7,10.29,3.7,10.29a53.79,53.79,0,0,1-.41,7s0,13.35,0,20c0,0,1.61,5.12,18.43,3.52,15-1.42,15.32-6.53,15.32-6.53A31.46,31.46,0,0,0,403.78,281.59Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M382.51,200.13a10.64,10.64,0,0,0-9.21,3.34c-5.86,6.6.57,11.46.57,11.46l8.64-14.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.32,216.31s-2.55,3.83-2.22,4.24a6,6,0,0,0,1.94.84Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.1,204.18c-2.47,1.27-6.74,3.61-7.86,12.69-1.15,9.33.92,12.57,2.19,13.8.85.83,5.28,1.14,7.59.43,2.9-.89,9.17-4,12.11-8.78,3.47-5.65,4.21-13.2.23-16.17C388.76,202,382.19,203.11,380.1,204.18Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.87,214.91c-5.17-2.63-3.85-9.49-3.85-9.49s7.38-10.55,21-3.73c4.71,2.36,7.54,7.72,7.43,14h0a14.78,14.78,0,0,1-14.78,14.78h0a8.62,8.62,0,0,1-8.62-8.62v-.57l.44.14a4.37,4.37,0,0,0,4-1.07c2.27-2,2.54-5.79-.33-6.75S379.8,216,379.8,216h0L378.69,219a2.17,2.17,0,0,1-1.3-2.78A2.11,2.11,0,0,1,378.87,214.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.62 217.01 323.04 229.32 334.6 262.63 357.56 250.27 347.62 217.01",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.45 220.23 325.83 230.56 336.07 259.21 355.33 248.84 346.45 220.23",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.09,223.23l-.38-1c-.21-.56-1.92-.25-3.82.69l-3.63,1.79c-1.89.94-3.26,2.16-3.05,2.73l.38,1Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.76,219.18c-.13-.36-.87-.31-1.66.1l-1.42.73s-.83-2.2-4.1-.74-2.57,4-2.57,4l-1.51.8c-.83.44-1.43,1.09-1.34,1.44l.17.65L342,219.83Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.38,220.62c-1.18.56-1.64.83-1.32,1.7s.71,1.7.71,1.7l-5.6,2.81s-.44-1.26-.64-1.74-.59-.73-1.48-.28l-.33-.36,8.84-4.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.32,223.29l-.37-1c-.21-.56-1.92-.26-3.82.68l-3.63,1.8c-1.9.94-3.26,2.16-3.05,2.72l.37,1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.42,236.64c-3.87-.06-6.21.28-11.49,8.12S351.85,267,350.71,268.91c-1.6,2.6-2,6.59-.66,9,1.21,2.27,3.35,3.06,9.44-3.41,4.5-4.79,14-17.51,14-17.51S380.84,243.28,378.42,236.64Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.45,279.58c-3.19,1-14.9-12.94-18.15-17.13a48.44,48.44,0,0,0-9.14-9.28c-4.51-3.45-3.76-8.62-1.69-13.33.72-1.64,3-.53,3-.53l.79,2.27,1.36,3.93c.95.91,1.5,1.21,1.56.94.13-.5-.66-2.61-.61-4.8.07-2.63,1.89-.87,2.42.06a32.77,32.77,0,0,1,1.87,4.39c.88,2.37.46,4.74,1.56,6.37s17,14.83,17,14.83Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.82,271.68s-11.21,6.62-26.91,0a230.6,230.6,0,0,0-2.85,24.88c-.56,10.62-1.79,33.41-1.79,33.41s4.63,5.41,21.17,4.31c15.9-1,18.7-5.2,18.7-5.2s0-20.47.12-29.42C407.37,288.22,405.77,282,398.82,271.68Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.82,271.68s-11.21,6.62-26.91,0a230.6,230.6,0,0,0-2.85,24.88c-.56,10.62-1.79,33.41-1.79,33.41s4.63,5.41,21.17,4.31c15.9-1,18.7-5.2,18.7-5.2s0-20.47.12-29.42C407.37,288.22,405.77,282,398.82,271.68Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,211.29l2.63-2.4a2.3,2.3,0,0,0-3.89,2.22c-.32,0-.65-.05-1-.05v21.08a11,11,0,0,0,10.95,11V222A11,11,0,0,0,404,211.29Z",
    style: {
      fill: "#263238"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpreadsheetsAmico);
export default __webpack_public_path__ + "static/media/Spreadsheets-amico.f4769c3a9b624b861599e989fabb27e5.svg";
export { ForwardRef as ReactComponent };